import { render } from "./ShiftPermissionCommentsModal.vue?vue&type=template&id=e17663d8&scoped=true"
import script from "./ShiftPermissionCommentsModal.vue?vue&type=script&lang=js"
export * from "./ShiftPermissionCommentsModal.vue?vue&type=script&lang=js"

import "./leave-comment-modal.scss?vue&type=style&index=0&id=e17663d8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e17663d8"]])

export default __exports__